import _ from "lodash";
import React from "react";
import { formatMessage } from "../../translations/formatMessage";

interface IProps {
  meta: any;
  intl: any;
  className?: string;
  isSelectAsset?: boolean;
}
const FormikFormErrorHandler: React.FC<IProps> = (props) => {
  let _error: string = props.meta.error
    ? props.intl.formatMessage({ id: props.meta.error })
    : props.meta.error;

  if (props.isSelectAsset && _error) {
    if (_error.includes("object") || _error.includes("Object")) {
      _error = formatMessage("below_topic_error");
    }
  }

  return (
    <>
      {props.meta.touched &&
        ((props.meta.error && (
          <span
            data-testid="testError"
            className={
              props.className ? props.className : "text-danger errorMessage"
            }
          >
            {_error}
          </span>
        )) ||
          (props.meta.warning && (
            <span data-testid="testWarn" className="text-danger">
              {props.meta.warning}
            </span>
          )))}
    </>
  );
};

export default FormikFormErrorHandler;
